import { Divider, Grid } from "@material-ui/core";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Button, CardActionArea, CardActions, Box, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CheckCircleIcon from '@material-ui/icons/CheckCircle'; // Added for green check icons
import InspectionImage from './../../Assets/Images/inspection.webp';
import ProductivityImage from './../../Assets/Images/productivity.webp';
import SamplingImage from './../../Assets/Images/sampling.webp';
import CallIcon from '@mui/icons-material/Call';
import RequestQuoteIcon from '@mui/icons-material/RequestQuoteTwoTone';
import useStyles from './Services.Styles';
import { Link } from 'react-router-dom';

function Services() {
    const classes = useStyles();

    return (
        <main>
            <Grid container spacing={4} alignItems="stretch" justifyContent="center">
                {/* Sampling & Testing Card */}
                <Grid item xs={12} md={6} lg={4}>
                    <Card className={classes.card}>
                        <Link to="/service-areas#sampling-section" style={{ textDecoration: 'none' }}>
                            <CardActionArea>
                                <CardMedia
                                    component="img"
                                    className={classes.images}
                                    image={SamplingImage}
                                    alt="Our Services include State Certified Well Water Testing"
                                    loading="lazy"
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="h2" component="h2" className={classes.cardTitle} style={{ fontFamily: 'serif' }}>
                                        Sampling & Testing
                                    </Typography>
                                    <Typography variant="h3" component="h3" className={classes.cardSubtitle}>
                                        Well Water Testing to Ensure Local Health Code Compliance
                                    </Typography>
                                    <Divider style={{ height: 2, marginTop: 14 }} />
                                    <List className={classes.bulletList}>
                                        {[
                                            "Bacterial and Potability Testing",
                                            "Heavy Metals Testing (upon request)",
                                            "VA, FHA, USDA & HUD Loan Compliance Testing",
                                            "State Certified Lab for all Testing"
                                        ].map((item, i) => (
                                            <ListItem key={i} className={classes.listItem}>
                                                <ListItemIcon>
                                                    <CheckCircleIcon className={classes.icon} />
                                                </ListItemIcon>
                                                <ListItemText primary={item} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </CardContent>
                            </CardActionArea>
                        </Link>
                        <CardActions style={{ padding: 0 }}>
                            <Box className={classes.buttonContainer}>
                                <Button
                                    size="small"
                                    className={classes.contactButton}
                                    component={Link}
                                    to="/contact"
                                    startIcon={<RequestQuoteIcon />}
                                >
                                    Get a Quote
                                </Button>
                                <Button
                                    size="small"
                                    className={classes.contactButton}
                                    component="a"
                                    href="tel:+12083523909"
                                    startIcon={<CallIcon />}
                                >
                                    (208) 352-3909
                                </Button>
                            </Box>
                        </CardActions>
                    </Card>
                </Grid>

                {/* Flow Rate / Productivity Card */}
                <Grid item xs={12} md={6} lg={4}>
                    <Card className={classes.card}>
                        <Link to="/service-areas#productivity-section" style={{ textDecoration: 'none' }}>
                            <CardActionArea>
                                <CardMedia
                                    component="img"
                                    className={classes.images}
                                    image={ProductivityImage}
                                    alt="Flow Rate Monitoring for Water Testing and Inspection Services"
                                    loading="lazy"
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="h2" component="h2" className={classes.cardTitle} style={{ fontFamily: 'serif' }}>
                                        Productivity
                                    </Typography>
                                    <Typography variant="h3" component="h3" className={classes.cardSubtitle}>
                                        Flow Rate Monitoring (GPM)
                                    </Typography>
                                    <Divider style={{ height: 2, marginTop: 14 }} />
                                    <List className={classes.bulletList}>
                                        {[
                                            "HUD 4000.1 Productivity Verification",
                                            "VA, FHA, USDA & HUD Loan Compliance Testing",
                                            "System Performance & Flow Rate Analysis",
                                            "Well Production Testing for Real Estate Sales"
                                        ].map((item, i) => (
                                            <ListItem key={i} className={classes.listItem}>
                                                <ListItemIcon>
                                                    <CheckCircleIcon className={classes.icon} />
                                                </ListItemIcon>
                                                <ListItemText primary={item} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </CardContent>
                            </CardActionArea>
                        </Link>
                        <CardActions style={{ padding: 0 }}>
                            <Box className={classes.buttonContainer}>
                                <Button
                                    size="small"
                                    className={classes.contactButton}
                                    component={Link}
                                    to="/contact"
                                    startIcon={<RequestQuoteIcon />}
                                >
                                    Get a Quote
                                </Button>
                                <Button
                                    size="small"
                                    className={classes.contactButton}
                                    component="a"
                                    href="tel:+12083523909"
                                    startIcon={<CallIcon />}
                                >
                                    (208) 352-3909
                                </Button>
                            </Box>
                        </CardActions>
                    </Card>
                </Grid>

                {/* System Inspection Card */}
                <Grid item xs={12} md={6} lg={4}>
                    <Card className={classes.card}>
                        <Link to="/service-areas#system-inspection-section" style={{ textDecoration: 'none' }}>
                            <CardActionArea>
                                <CardMedia
                                    component="img"
                                    className={classes.images}
                                    image={InspectionImage}
                                    alt="Our Services include well Water Testing and System Inspection"
                                    loading="lazy"
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="h2" component="h2" className={classes.cardTitle} style={{ fontFamily: 'serif' }}>
                                        System Inspection
                                    </Typography>
                                    <Typography variant="h3" component="h3" className={classes.cardSubtitle}>
                                        Water and Wastewater System Inspection
                                    </Typography>
                                    <Divider style={{ height: 2, marginTop: 14 }} />
                                    <List className={classes.bulletList}>
                                        {[
                                            "Operational Checks and Performance Validation",
                                            "Consultation and Recommendations for Compliance",
                                            "Full Compliance with State and Local Requirements",
                                            "VA, FHA, USDA & HUD Loan Compliance Testing"
                                        ].map((item, i) => (
                                            <ListItem key={i} className={classes.listItem}>
                                                <ListItemIcon>
                                                    <CheckCircleIcon className={classes.icon} />
                                                </ListItemIcon>
                                                <ListItemText primary={item} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </CardContent>
                            </CardActionArea>
                        </Link>
                        <CardActions style={{ padding: 0 }}>
                            <Box className={classes.buttonContainer}>
                                <Button
                                    size="small"
                                    className={classes.contactButton}
                                    component={Link}
                                    to="/contact"
                                    startIcon={<RequestQuoteIcon />}                                  
                                >
                                    Get a Quote
                                </Button>
                                <Button
                                    size="small"
                                    className={classes.contactButton}
                                    component="a"
                                    href="tel:+12083523909"
                                    startIcon={<CallIcon />}
                                >
                                    (208) 352-3909
                                </Button>
                            </Box>
                        </CardActions>
                    </Card>
                </Grid>
            </Grid>
        </main>
    );
}

export default Services;
